
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/precios-y-planes",
      function () {
        return require("private-next-pages/precios-y-planes/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/precios-y-planes"])
      });
    }
  